<div class="swapa-video-block" *ngIf="config && playerUrl">
    <div class="swapa-video-block-media">
        <iframe class="swapa-video-block-player"
                [src]="playerUrl"
                [title]="config.Header || 'Video'"
                loading="lazy"
                allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen></iframe>
    </div>
    <h2 class="swapa-video-block-header" *ngIf="config.Header" [title]="config.Header">{{ config.Header }}</h2>
    <p class="swapa-video-block-summary" *ngIf="config.Summary" [title]="config.Summary">{{ config.Summary }}</p>
</div>
